import { I18n } from '@calendly/i18n';
import { SimplePopup } from '@calendly/ui/components/popup';
import classNames from 'classnames';
import { useEffect, useState, forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { setGetParams } from 'actions/core/navigation';
import { useSingleUseLinkSidebar } from 'features/single_use_link_sidebar';
import { useDeletePollMutation } from '../polls/api';
import { useClosePollSidebar } from '../polls/helpers';
import { useBatchDeleteSingleUseLinksMutation } from '../single_use_links/api';
const popupDescriptionCss = "p5fd63q";
const PopupDescription = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(popupDescriptionCss, props.className)} />;
});
export const CancelMeetingModal = ({
  link,
  onClose,
  isPoll = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [cancelPoll] = useDeletePollMutation();
  const [cancelSingleUseLink] = useBatchDeleteSingleUseLinksMutation();
  const {
    closeSidebar
  } = useSingleUseLinkSidebar();
  const dispatch = useDispatch();
  const closePollSidebar = useClosePollSidebar();
  const resetPollsUrl = () => {
    if (!isPoll) return;
    closePollSidebar();
    dispatch(setGetParams({
      trigger_delete: null,
      id: null
    }));
  };
  const onConfirm = () => {
    if (isPoll) {
      cancelPoll(link.id);
      resetPollsUrl();
    } else {
      cancelSingleUseLink({
        singleUseLinkIds: [link.id],
        name: link.name,
        onSuccess: closeSidebar
      });
    }
    setIsOpen(false);
  };
  const onDismiss = () => {
    onClose();
    setIsOpen(false);
  };
  useEffect(() => {
    if (link?.id) {
      setIsOpen(true);
    }
  }, [link?.id]);
  if (!link?.id) return null;
  return <SimplePopup isOpen={isOpen} onClose={onDismiss} title={I18n.t('publisher.scheduled_events.pending.delete_title')} cancelLabel={I18n.t('publisher.action.cancel')} confirmLabel={I18n.t('publisher.action.delete')} onConfirm={onConfirm}>
      <PopupDescription>
        {I18n.t('publisher.scheduled_events.pending.delete_description')}
      </PopupDescription>
    </SimplePopup>;
};

require("./cancel_meeting_modal.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./cancel_meeting_modal.js");